import type { TFieldAssetType, TLngLat } from 'App/Map/types'

export const getIdForLngLat = ({
  fieldAssetType,
  lngLat,
}: {
  fieldAssetType: TFieldAssetType
  lngLat: TLngLat
}) => {
  return `${fieldAssetType}-${lngLat}`
}
